import { PREFETCH_GLOBAL_KEY } from './operations';

type PrefetchBody = { data?: unknown; errors?: unknown } | null;
type PrefetchStore = Record<string, Promise<PrefetchBody> | undefined>;

function getPrefetchStore(): PrefetchStore | undefined {
  return (globalThis as Record<string, unknown>)[PREFETCH_GLOBAL_KEY] as
    | PrefetchStore
    | undefined;
}

// Hands a request the inline <head> script already started (see
// build-inline-script.ts) back to TanStack Query. A query's queryFn calls this
// first and falls back to gqlClient on a null result.
//
// One-shot and fail-open: the entry is deleted on read so a prefetch is never
// served twice, and any miss, network error, or partial / GraphQL-error
// response returns null. The fallback gqlClient.request then owns 401 renewal,
// error shaping, and Sentry breadcrumbs — the prefetch never surfaces errors.
export async function consumePrefetch<TData>(
  operationName: string,
): Promise<TData | null> {
  const store = getPrefetchStore();
  const pending = store?.[operationName];
  if (!store || !pending) return null;
  delete store[operationName];
  try {
    const body = await pending;
    if (!body || body.errors || body.data == null) return null;
    return body.data as TData;
  } catch {
    return null;
  }
}
